import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@NgModule({
	exports: [
		TableModule, 
		InputTextModule, 
		MessageModule,
		CheckboxModule,
		RadioButtonModule,
		CardModule,
		ConfirmDialogModule,
		ToastModule,
		ButtonModule,
		ScrollPanelModule,
		DividerModule,
		FormsModule,
		DialogModule,
		SelectModule,
		ToggleSwitchModule
	],
	declarations: [],
})
export class PrimeModule {}
